module.exports = __webpack_public_path__ + "img/73.3cb2e8ff.jpg";